import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import App from './App';
import 'ant-design-vue/dist/antd.css';
import router from './router'
import { config } from './config'
import { ossDirectUpload } from './request'
// import * as XLSX from 'xlsx'

// 挂载前从后端拉取 merchant 地址 + 标题（由后端 SystemType 决定），改后端即可，前端不用重编
fetch((config.server || '') + '/FrontConfig/Get')
  .then(r => r.json())
  .then(d => {
    if (d) {
      if (d.merchantApiServer) config.merchantApiServer = d.merchantApiServer;
      if (d.merchantServer) config.merchantServer = d.merchantServer;
      if (d.title) { config.title = d.title; document.title = d.title; }
    }
  })
  .catch(() => {})
  .finally(() => {
    const app = createApp(App);
    // 全局注入客户端直传方法，供各页面 <a-upload :custom-request="ossDirectUpload"> 使用
    app.mixin({ methods: { ossDirectUpload } });
    app.use(Antd).use(router).mount('#app');
  });
